import { lazy } from 'react';
var DOC_PAGE = ['01', '02', '03', '04', '05'];
var DOC_ROUTES = DOC_PAGE.map(function (obj) { return ({
    path: "/DOC00/DOC000" + obj,
    component: lazy(function () { return import("view/Project/DOC/DOC000" + obj); }),
}); });
export default DOC_ROUTES;
